'use client';

import { PageViewEvent } from '@/lib/use-page-view-event';
import { Fragment } from 'react';
import HomeRecommend from '../HomeRecommend';
import CategoriesLazyLoad from './home-categories-lazy-load.tsx';
import LivingHiseaLazyLoad from './home-living-hisea-lazy-load.tsx';
import ProvenInTheFieldLazyLoad from './home-proven-in-the-field-lazy-load.tsx';
import WhyHiseaLazyLoad from './home-why-hisea-lazy-load.tsx';
import TopCarousel from './topCarousel';

const HomePage = ({ hotProducts, socialMedias, cmsVideos, cmsBanners }) => {
  return (
    <Fragment>
      <PageViewEvent />
      <TopCarousel
        cmsVideos={cmsVideos}
        cmsBanners={cmsBanners}
      />
      <h1 className='sr-only'>HISEA: Waterproof & Rain Boots, Waders, Work Safety Shoes</h1>
      <HomeRecommend hotProductData={hotProducts} />
      <CategoriesLazyLoad />
      <WhyHiseaLazyLoad />
      <ProvenInTheFieldLazyLoad />
      <LivingHiseaLazyLoad socialMedias={socialMedias} />
    </Fragment>
  );
};

export default HomePage;
